export class PrescriptionDrugStock{
    constructor() {
    }

    public inventoryDetailId?:string;
    public stockId?:string;
    public drugId?:string;
    public brandName?:string;
    public drugPackage?:number;
    public expireDate?:string;
    public stockName?:string;
    public inventoryCount?:number;
    public saleCount?:number;
    public price?:number;
    public patientSharePrice?:number;
    public governmentSharePrice?:number;
    public insuranceSharePrice?:number;
    public genericCode?:number;
    public genericName?:string;
    public loading:boolean=true;
}